module.exports = __webpack_public_path__ + "img/5Gdiagram.341d41c6.png";